// Prompt, schema och tolkning för AI-förslagen på segment och organisationstyp.
// Ren logik (bara .js-importer) – används av kundKategoriAI.js och av
// scripts/kategori-ai-test.mjs, som skickar exakt samma anrop mot gatewayen.
import { SEGMENT_OPTIONS, SEGMENT_BESKRIVNINGAR, ORGANISATIONSTYP_OPTIONS, tolkaSegment, tolkaOrganisationstyp } from './kundformular.js';

export const OKANT = 'okänt';
export const MAX_PER_ANROP = 25;

// Det äldre fältet orgType (dolt på kundkortet) som ledtråd till modellen
const ORG_TYPE_LEDTRAD = {
  verk: 'Myndighet / Verk', statligab: 'Statligt aktiebolag', kommun: 'Kommun', region: 'Region', ab: 'Aktiebolag',
};

export const SCHEMA = {
  type: 'object',
  properties: {
    forslag: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: { type: 'string' },
          segment: { type: 'string', enum: [...SEGMENT_OPTIONS, OKANT] },
          organisationstyp: { type: 'string', enum: [...ORGANISATIONSTYP_OPTIONS, OKANT] },
          motivering: { type: 'string' },
        },
        required: ['id', 'segment', 'organisationstyp', 'motivering'],
        additionalProperties: false,
      },
    },
  },
  required: ['forslag'],
  additionalProperties: false,
};

export const SYSTEM = `Du kategoriserar svenska organisationer i ett CRM för säljet av Flatbox (granskning av bygghandlingar).
Svara bara med värden ur listorna, eller "${OKANT}" om du inte är säker. Gissa inte.

Segment (vilken marknad organisationen tillhör):
${SEGMENT_OPTIONS.map(s => `- ${s}: ${SEGMENT_BESKRIVNINGAR[s]}`).join('\n')}

Organisationstyp (juridisk/ägarmässig form):
${ORGANISATIONSTYP_OPTIONS.map(s => `- ${s}`).join('\n')}

Riktlinjer:
- Affärsverk (t.ex. Svenska kraftnät) är "Statlig myndighet".
- Aktiebolag som ägs av staten är "Statligt bolag", av kommuner "Kommunalt bolag", av regioner "Regionalt bolag".
- Teknikkonsulter och arkitektbyråer är "Konsultbolag". Övriga privata företag är "Bolag".
- Leverantörer och andra som inte passar något segment får "${OKANT}" för segment.
- Org.nr som börjar på 2 tillhör offentliga organisationer (myndigheter, kommuner, regioner); 5 är aktiebolag.
- Motiveringen är en kort mening på svenska.`;

export function kundText(k) {
  const rader = [
    `id: ${k.id}`,
    `Namn: ${k.name || ''}`,
    k.orgNumber && `Org.nr: ${k.orgNumber}`,
    k.companyForm && `Bolagsform: ${k.companyForm}`,
    k.industry && `Bransch: ${k.industry}`,
    k.orgType && `Tidigare typmarkering: ${ORG_TYPE_LEDTRAD[k.orgType] || k.orgType}`,
    k.website && `Webbplats: ${k.website}`,
    k.description && `Beskrivning: ${String(k.description).slice(0, 600)}`,
  ];
  return rader.filter(Boolean).join('\n');
}

/** Anropet till callClaude (callClaudeJSON) för en omgång kunder. */
export function kategoriAnrop(kunder) {
  if (kunder.length > MAX_PER_ANROP) throw new Error(`högst ${MAX_PER_ANROP} kunder per anrop`);
  return {
    model: 'claude-opus-5-5',
    max_tokens: 6000,
    schema: SCHEMA,
    system: SYSTEM,
    messages: [{ role: 'user', content: `Kategorisera kunderna:\n\n${kunder.map(kundText).join('\n\n')}` }],
  };
}

/** Modellens svar → förslag per id, bara för begärda id:n och bara värden ur listorna. */
export function tolkaForslag(raw, ids) {
  const out = {};
  for (const f of raw?.forslag || []) {
    if (!ids.includes(f.id)) continue;
    out[f.id] = {
      segment: tolkaSegment(f.segment) || OKANT,
      organisationstyp: tolkaOrganisationstyp(f.organisationstyp) || OKANT,
      motivering: String(f.motivering || ''),
    };
  }
  return out;
}
